import { Observable } from 'rxjs';

import { RoleType } from '../permissions/permissions.types';

import { Role, WoPermission } from '@iss/libs/graphql';

export type PermissionToken = Role | RoleType | WoPermission;

type AllOf = Readonly<{
  allOf: readonly PermissionToken[];
}>;

type AnyOf = Readonly<{
  anyOf: readonly PermissionToken[];
}>;

export type PermissionTokens = PermissionToken | AllOf | AnyOf | '*';

export type RequiredPermissionsMatrix<T extends string> = Record<T, PermissionTokens>;

let roles: Set<string> | undefined;
export const isRole = (token: unknown): token is Role => {
  roles = roles || new Set<string>(Object.values(Role));
  return typeof token === 'string' && roles.has(token);
};

let roleTypes: Set<string> | undefined;
export const isRoleType = (token: unknown): token is RoleType => {
  roleTypes = roleTypes || new Set<string>(Object.values(RoleType));
  return typeof token === 'string' && roleTypes.has(token);
};

let woPermissions: Set<string> | undefined;
export const isWoPermission = (token: unknown): token is WoPermission => {
  woPermissions = woPermissions || new Set<string>(Object.values(WoPermission));
  return typeof token === 'string' && woPermissions.has(token);
};

export const isAllOf = (value: PermissionTokens): value is AllOf => typeof value === 'object' && 'allOf' in value;
export const isAnyOf = (value: PermissionTokens): value is AnyOf => typeof value === 'object' && 'anyOf' in value;

export interface AuthService {
  bootstrap(): Observable<unknown>;
  logout(): Observable<unknown>;
  isLoggedIn(): Observable<boolean>;
}

export type ResetPasswordFn = (redirectUri?: string) => string;
